import { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  Dropdown,
  Modal,
  ModalBody,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import Symbol from '../../utils/symbol';
import * as PropTypes from 'prop-types';
import { PLATFORM_STATIC_ICONS_PNG } from '../../../config/icons';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import isEqual from 'lodash/isEqual';
import {
  addUrl,
  getActiveConversation,
  setConversationListNextpageFunction,
  getConversationListForNextPage,
  getCoversationDetails,
  setActiveConversation,
  setConversationsFilters,
  resetAllFilter,
  setConversationFilterValues,
  runConversationBulkOperation,
  getConversationsList,
  setConversationAttributes,
  updateConversationAttributesLocaly,
  getLatestConversationsDetailsUpdates,
  getConversationListUpdates,
  getNotifications,
  resetNotifications,
  updateNotificationsCount,
  removeConversationFromList
} from '../../../redux/slices/communication';
import StarRating from '../utils/starRating';
import { useTranslate } from '@tolgee/react';
import { ConversationsFiltersCard } from './conversationsFiltersCard';
import { useParams } from 'react-router-dom';
import { getImageUrl } from '../../../firebase/utils';
import ConversationListLoader from '../loaders/conversationListLoader';
import { PATH_PAGE } from '../../../routes/paths';
import { getCurrentLocationUUID } from '../../../utils/communicationUtils';
import { useIdleTimer } from 'react-idle-timer';
import {
  COMMUNICATION_ENABLE_COMMENTS,
  COMMUNICATION_ENABLE_DIRECT_MESSAGES,
  COMMUNICATION_ENABLE_REVIEWS,
  PRIORITIES,
  PULLING_INTERVAL_CONVERSATIONS_LIST,
  TIME_BEFORE_IDLE
} from '../constants';
import { useClickAway } from 'react-use';
import InfiniteScrollLoader from '../loaders/infiniteScrollLoader';
import FeaturesToolTip from '../../featuresToolTip';
import { formatDate } from '../../../utils/dateUtils';

export default function ConversationsList() {
  // get uuid from url
  const { conversationUUid } = useParams();

  const { t } = useTranslate();
  const {
    data: {
      filters,
      conversationList: {
        data,
        isLoading,
        nextPage,
        nextPageIsLoading,
        getNextPageFunction
      }
    },
    ui: { rightMenuOpen, leftMenuOpen, conversationsFilters }
  } = useSelector((state) => state.communication);
  useEffect(() => {
    dispatch(
      setConversationListNextpageFunction(() =>
        getConversationListForNextPage(() => {})
      )
    );
  }, []);
  useEffect(() => {
    if (conversationUUid) {
      dispatch(getActiveConversation(conversationUUid));
      dispatch(getCoversationDetails(conversationUUid));

      dispatch(setActiveConversation({ uuid: conversationUUid }));
    }
  }, [conversationUUid]);
  const [query, setQuery] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (query === '') {
      dispatch(getConversationListForNextPage(() => {}));
    }
  }, [query]);

  const [isIdle, setIsIdle] = useState(false);
  const onIdle = () => {
    setIsIdle(true);
  };

  const onActive = () => {
    setIsIdle(false);
  };
  useIdleTimer({
    timeout: TIME_BEFORE_IDLE, // 5 minutes
    onIdle,
    onActive,
    debounce: 250
  });
  // register a pulling function to get the latest data for conversation details
  useEffect(() => {
    // when user goes idle, stop pulling the data
    const interval = setInterval(() => {
      // check if user is idle
      if (isIdle) return;
      // get the latest data for the conversation
      dispatch(getConversationListUpdates());
      dispatch(getNotifications());
    }, PULLING_INTERVAL_CONVERSATIONS_LIST);
    if (isIdle) clearInterval(interval);
    return () => clearInterval(interval);
  }, [isIdle]);

  const scrollableDivRef = useRef(null); // Create a ref

  const scrollComponentStyle = {
    overflow: 'auto hidden !important',
    overflowX: 'hidden'
  };
  const CUSTOM_CHAT_BREAKPOINT = 1400;
  const [isLargeScreen, setIsLargeScreen] = useState(
    typeof window !== 'undefined' && window.innerWidth >= CUSTOM_CHAT_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= CUSTOM_CHAT_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  console.log('conversations data', data);
  return (
    <Col xs={2} style={{ width: isLargeScreen ? 400 : 300 }}>
      <div className="card p-3 d-flex align-items-center position-relative h-100">
        <p className="fw-bold text-muted text-align-center mb-2 user-select-none">
          {t('communication.conversationsList.title')}
        </p>
        <ConversationTopBar />

        {conversationsFilters && <ConversationsFiltersCard />}

        {/*        <input
          type="text"
          onChange={handleSearch}
          value={query}
          className="form-control form-control-lg"
          placeholder="search"
        /> */}
        <div className="mt-5" />
        <div
          className="d-flex flex-column gap-5 w-100"
          style={{ overflowY: 'auto', overflowX: 'hidden' }}
          ref={scrollableDivRef} // Attach the ref here
          // style={{ maxHeight: 'calc(100vh - 350px)' }}
        >
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
              <ConversationListLoader />
            </div>
          ) : (
            <>
              {data?.length > 0 ? (
                <InfiniteScroll
                  dataLength={data?.length}
                  next={() => {
                    dispatch(getNextPageFunction());
                  }}
                  hasMore={nextPage}
                  loader={
                    <div className="w-100 d-flex justify-content-center align-items-center">
                      <InfiniteScrollLoader />
                    </div>
                  }
                  scrollableTarget={scrollableDivRef.current}
                  endMessage={
                    <p className={'d-none'} style={{ textAlign: 'center' }}>
                      <b>
                        {t(
                          'communication.conversationsList.no_more_conversartions'
                        )}
                      </b>
                    </p>
                  }
                  style={scrollComponentStyle}
                >
                  {data?.map((conversation, i) => (
                    <div key={i}>
                      <ConversationCard conversation={conversation} />
                    </div>
                  ))}
                </InfiniteScroll>
              ) : (
                <div
                  className="d-flex flex-column justify-content-center align-items-center overflow-hidden text-center"
                  style={{ wordBreak: 'break-word', height: '100vh' }}
                >
                  <p>
                    {t(
                      'communication.conversationsList.no_conversations_found'
                    )}
                  </p>
                  <p className={'text-muted px-10 d-none'}>
                    {t(
                      'communication.conversationsList.no_conversations_found_tubtitle'
                    )}
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Col>
  );
}
export const ConversationCard = ({ conversation }) => {
  const dispatch = useDispatch();
  const {
    data: { activeConversation, urls }
  } = useSelector((state) => state.communication);
  const { locationslug } = useParams();
  const selectConversation = () => {
    // set conversationUUid in url without reloading the page
    window.history.pushState(
      null,
      null,
      !getCurrentLocationUUID()
        ? PATH_PAGE.communication.replace(
            ':conversationUUid',
            conversation.uuid
          )
        : PATH_PAGE.location_communication
            .replace(':locationslug', locationslug)
            .replace(':conversationUUid', conversation.uuid)
    );

    dispatch(setActiveConversation(conversation));
    dispatch(getCoversationDetails(conversation.uuid));
    // set conversation as seen when selected
    if (conversation.read) return;
    dispatch(
      setConversationAttributes(conversation.uuid, {
        read: true
      })
    );
    dispatch(
      updateConversationAttributesLocaly(conversation.uuid, {
        read: true
      })
    );
    dispatch(updateNotificationsCount(conversation.platform, -1));
  };
  const getInitialis = (name) => {
    if (!name) return '';
    const initials = name
      .split(' ')
      .map((n) => n[0])
      .join('');
    // return uppercase initials
    return initials.toUpperCase();
  };

  // set an empty image as default, to avoid the image flickering until the image url has been fetched
  const [imageUrl, setImageUrl] = useState(
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
  );

  useEffect(() => {
    if (conversation?._preview_image) {
      setImageUrl(conversation?._preview_image);
    } else if (conversation?._preview_image_file) {
      if (urls?.[conversation?._preview_image_file])
        setImageUrl(urls[conversation?._preview_image_file]);
      else
        getImageUrl(conversation?._preview_image_file)
          .then((url) => {
            dispatch(addUrl(conversation?._preview_image_file, url));
            setImageUrl(url);
          })
          .catch((err) => {
            console.log(err);
            setImageUrl(null);
          });
    } else {
      setImageUrl(null);
    }
  }, [conversation]);
  const menuRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  useClickAway(menuRef, () => {
    setShowMenu(false);
  });

  const actions = [
    {
      name: 'close_conversation',
      icon: 'fa-duotone text-success fa-circle-check',
      description: 'close_conversation_description',
      onClick: () => {
        dispatch(
          setConversationAttributes(conversation.uuid, {
            status: 1
          })
        );
        dispatch(
          updateConversationAttributesLocaly(conversation.uuid, {
            status: 1
          })
        );

        if (activeConversation?.uuid === conversation.uuid) {
          dispatch(setActiveConversation(null));
        }
        // remove from conversation list
        dispatch(removeConversationFromList(conversation.uuid));
      }
    },
    {
      name: 'mark_as_spam',
      icon: 'fa-duotone fa-octagon-exclamation text-danger',
      description: 'mark_as_spam_description',
      onClick: () => {
        dispatch(
          setConversationAttributes(conversation.uuid, {
            is_spam: true
          })
        );
        dispatch(
          updateConversationAttributesLocaly(conversation.uuid, {
            is_spam: true
          })
        );
        if (activeConversation?.uuid === conversation.uuid) {
          dispatch(setActiveConversation(null));
        }
        // remove from conversation list
        dispatch(removeConversationFromList(conversation.uuid));
      }
    },
    {
      name: 'mark_as_read',
      icon: 'fa-duotone fa-eye text-primary',
      description: 'mark_as_read_description',
      onClick: () => {
        dispatch(
          setConversationAttributes(conversation.uuid, {
            read: true
          })
        );
        dispatch(
          updateConversationAttributesLocaly(conversation.uuid, {
            read: true
          })
        );
        dispatch(updateNotificationsCount(conversation.platform, -1));
      }
    }
  ];
  const { t } = useTranslate();
  return (
    <div
      className={`card p-2 w-100 shadow-xs cursor-pointer h-100 mb-5 ${
        activeConversation?.uuid === conversation.uuid
          ? 'border border-primary border-2'
          : 'border border-white border-2'
      } ${conversation.read ? '' : 'bg-light-primary'}`}
      onClick={selectConversation}
      onMouseEnter={() => {
        menuRef.current.style.display = 'block';
      }}
      onMouseLeave={() => {
        menuRef.current.style.display = 'none';
        setShowMenu(false);
      }}
    >
      <div className="d-flex flex-row justify-content-between   align-items-center">
        <div className="m-1">
          {conversation?.is_spam && (
            <i
              className="fa-solid fa-octagon-exclamation cursor-pointer text-danger"
              style={{ fontSize: '20px' }}
            ></i>
          )}
          {conversation?.is_marked && (
            <i
              className="fa-duotone fa-star cursor-pointer text-warning mx-2"
              style={{ fontSize: '20px' }}
            ></i>
          )}
        </div>
        <div className="d-flex flex-row  flex-end  align-items-center">
          <img
            src={PLATFORM_STATIC_ICONS_PNG[conversation.platform]}
            className="h-20px mx-1"
            key={PLATFORM_STATIC_ICONS_PNG[conversation.platform]}
          />
          {conversation.type === 'review' && (
            <div className="">
              <StarRating rating={conversation.rating} />
            </div>
          )}
          {conversation.type === 'comment' && (
            <div>
              <i
                className="fa-duotone fa-comment mx-1"
                style={{ fontSize: '20px' }}
              ></i>
            </div>
          )}
          {conversation.type === 'direct_message' && (
            <div>
              <i
                className="fa-duotone fa-envelope mx-1"
                style={{ fontSize: '20px' }}
              ></i>
            </div>
          )}
        </div>
      </div>

      <div className="d-flex align-items-center">
        <div>
          {imageUrl ? (
            <div className={'symbol symbol- symbol-50px'}>
              <img
                src={imageUrl}
                className="w-50px h-50px rounded"
                style={{ objectFit: 'cover' }}
                alt={''}
                onError={(e) => {
                  // set imageUrl to null if the image is not found
                  setImageUrl(null);
                }}
              />
            </div>
          ) : (
            <Symbol
              initials={getInitialis(
                conversation?._recepient_social_media_platform_user?.name
              )}
            /> /* todo update the initials */
          )}
        </div>
        <div className="px-2" style={{ width: 'calc(100% - 50px)' }}>
          <h5
            className={`m-0 p-0 fw-bold d-inline-block text-truncate user-select-none w-100 ${
              conversation.type === 'review' ? 'mt-1' : ''
            }`}
          >
            {conversation.title}
          </h5>
          <br className="m-0 p-0" />
          <div className="d-flex justify-content-between">
            <div className="text-muted d-inline-block text-truncate user-select-none w-100 overflow-hidden">
              {conversation.subtitle}
            </div>
            <div style={{ height: 10 }} className="mt-n3">
              <div className="" ref={menuRef} style={{ display: 'none' }}>
                <Dropdown
                  show={showMenu}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu(!showMenu);
                  }}
                >
                  <i className="fa-solid fa-ellipsis fs-1 p-0 px-1 m-0 mx-2 rounded cursor-pointer fs-1  pill "></i>

                  <Dropdown.Menu style={{ left: 'auto', right: 0 }}>
                    {actions.map((action) => (
                      <Dropdown.Item
                        key={action.name}
                        value={action.name}
                        active={action.name === ''}
                        onClick={action.onClick}
                      >
                        <div className="fw-bold h6 d-flex align-items-center ">
                          <i className={`${action.icon} mx-2`}></i>
                          <span>
                            {t(
                              `lomavis_communication.conversation_action.${action.name}`
                            )}
                          </span>
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center flex-row justify-content-between">
            <div className="d-flex align-items-center text-truncate">
              <i className="fa-duotone fa-sliders"></i>
              <span className="text-muted mx-1 d-inline-block text-truncate user-select-none w-100">
                {conversation?.location?.name}
              </span>
            </div>
            {conversation.assigned_to_user && (
              <div className="d-flex align-items-center truncate m-2 overflow-hidden flex-end text-primary">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      <span className=" fw-bold d-block fs-7 text-primary">
                        {conversation.assigned_to_user?.name}
                      </span>
                    </Tooltip>
                  }
                >
                  <p className="text-primary m-0 p-0 d-inline-block text-truncate user-select-none border border-primary rounded px-1">
                    {getInitialis(conversation.assigned_to_user?.name)}
                  </p>
                </OverlayTrigger>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center truncate mt-2 overflow-hidden flex-wrap">
        {conversation.priority !== null && (
          <i
            className="fa-solid fa-circle fs-4 mx-2"
            style={{ color: PRIORITIES[conversation.priority].color }}
          ></i>
        )}
        {conversation?.labels
          .slice()
          ?.sort((a, b) => a.text.localeCompare(b.text))
          ?.map((label, i) => (
            <div
              className="badge m-1"
              style={{
                backgroundColor: label.color.replace('opacity', '0.125'),
                color: label.color.replace('opacity', '1')
              }}
              key={i}
            >
              {label.text}
            </div>
          ))}
      </div>
      <div className={'d-flex justify-content-between text-end w-100 mt-1'}>
        <div className={'text-muted small'}>
          {conversation?.ticket_id && <div>#{conversation?.ticket_id}</div>}
        </div>
        <div className={'text-muted small'}>
          {formatDate(conversation?.platform_updated)}
        </div>
      </div>
    </div>
  );
};

ConversationCard.propTypes = {
  conversation: PropTypes.any
};

export const ConversationTopBar = () => {
  const dispatch = useDispatch();
  const {
    data: { filters, locations },
    ui: { conversationsFilters }
  } = useSelector((state) => state.communication);
  const filterIsActive = () => {
    const initialObject = {
      labels: [],
      assigned_user_uuid: null,
      read: null,
      is_spam: null,
      is_marked: null,
      platforms: [],
      priority: [],
      status: [],
      type: null,
      unassigned: null
    };
    return isEqual(filters, initialObject);
  };
  const onClickType = (item) => {
    if (item.value === null) {
      dispatch(resetAllFilter());
      dispatch(getConversationsList());
      return;
    }
    dispatch(
      setConversationFilterValues({
        ...filters,
        type: item.value
      })
    );
    dispatch(getConversationsList());
  };
  const types = [
    {
      title: 'all',
      value: null,
      icon: 'fa-duotone fa-earth-americas',
      onClick: onClickType,
      active: filters?.type === null
    },
    {
      title: 'direct_message',
      value: 'direct_message',
      icon: 'fa-duotone fa-envelope',
      onClick: onClickType,
      active: filters?.type === 'direct_message',
      feature: COMMUNICATION_ENABLE_DIRECT_MESSAGES
    },
    {
      title: 'review',
      value: 'review',
      icon: 'fa-duotone fa-star',
      onClick: onClickType,
      active: filters?.type === 'review',
      feature: COMMUNICATION_ENABLE_REVIEWS
    },
    {
      title: 'comment',
      value: 'comment',
      icon: 'fa-duotone fa-comment',
      onClick: onClickType,
      active: filters?.type === 'comment',
      feature: COMMUNICATION_ENABLE_COMMENTS
    }
  ];
  const { t } = useTranslate();
  const actions = [
    {
      name: 'mark_all_as_read',
      icon: 'fa-duotone fa-eye text-primary',
      description: 'mark_all_as_read_description',
      onClick: () => {
        dispatch(
          runConversationBulkOperation(
            {
              set_status_to_read: true,
              location_uuid: JSON.stringify(locations.map((item) => item.uuid))
            },
            () => {
              dispatch(resetNotifications());
              dispatch(getConversationsList());
              dispatch(getNotifications());
            }
          )
        );
      }
    },
    {
      name: 'mark_all_as_closed',
      icon: 'fa-duotone fa-circle-check text-success',
      description: 'mark_all_as_closed_description',
      onClick: () => {
        dispatch(
          runConversationBulkOperation(
            {
              set_status_to_closed: true,
              location_uuid: JSON.stringify(locations.map((item) => item.uuid))
            },
            () => {
              dispatch(resetNotifications());
              dispatch(getConversationsList());
              dispatch(getNotifications());
            }
          )
        );
      }
    }
  ];
  const [showDropdown, setShowDropdown] = useState(false);
  const dropDownRef = useRef(null);
  useClickAway(dropDownRef, () => {
    setShowDropdown(false);
  });
  const { userData } = useSelector((state) => state.userDetails);
  return (
    <div className="d-flex justify-content-between align-items-center w-100 my-4">
      <div>
        <Dropdown
          size="sm"
          className="btn-sm "
          onClick={() => setShowDropdown(!showDropdown)}
          show={showDropdown}
          ref={dropDownRef}
        >
          <div className={''}>
            <i className="fa-solid fa-ellipsis fs-1 p-2 rounded cursor-pointer fs-1 p-2 shadow-sm"></i>
          </div>

          <Dropdown.Menu>
            {actions.map((action) => (
              <Dropdown.Item
                key={action.name}
                value={action.name}
                active={action.name === ''}
                onClick={action.onClick}
              >
                <div className="fw-bold h6 d-flex align-items-center">
                  <i className={`${action.icon} mx-2`}></i>
                  {t(`lomavis_communication.bulk_actions.${action.name}`)}
                </div>
                <div className="fs-7 d-none">
                  {t(
                    `lomavis_communication.bulk_actions.${action.description}`
                  )}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="d-flex">
        {types.map((item) => {
          return (
            <div className="m-1" key={item.title}>
              {item.feature ? (
                <FeaturesToolTip
                  feature={item.feature}
                  featureIsActive={
                    userData?.feature_list_for_user[item.feature]
                  }
                  InnerComponent={() => (
                    <i
                      className={`${item.icon} p-2 rounded ${
                        userData?.feature_list_for_user[item.feature]
                          ? 'cursor-pointer'
                          : ''
                      } fs-1 p-2 shadow-sm ${
                        item.active ? 'text-primary' : ''
                      }`}
                      onClick={() =>
                        userData?.feature_list_for_user[item.feature] &&
                        item.onClick(item)
                      }
                    />
                  )}
                />
              ) : (
                <i
                  className={`${
                    item.icon
                  } p-2 rounded cursor-pointer fs-1 p-2 shadow-sm ${
                    item.active ? 'text-primary' : ''
                  }`}
                  onClick={() => item.onClick(item)}
                />
              )}
            </div>
          );
        })}
      </div>
      <div>
        <div>
          <i
            className={`p-2 rounded shadow-sm fa-duotone fa-bars-filter m-1 cursor-pointer fs-1 ${
              conversationsFilters ? 'text-primary' : ''
            }`}
            onClick={() =>
              dispatch(setConversationsFilters(!conversationsFilters))
            }
          >
            {!filterIsActive() ? (
              <i
                className="fa-solid fa-circle text-primary fs-8 position-absolute "
                style={{
                  top: 3,
                  right: 2,
                  transform: 'translate(50%, -50%)'
                }}
              ></i>
            ) : (
              ''
            )}
          </i>
        </div>
      </div>
    </div>
  );
};
